import { vsprintf } from "sprintf-js";

/* eslint-disable */
String.prototype.sprintf = function (): string {
  const args = Array.prototype.slice.call(arguments)
  return vsprintf(this.valueOf(), args)
}
